import React, {useState,useEffect} from 'react'
import { Link } from 'react-router-dom';
import './Dropdown.css';

const Dropdown = ({
    title = '',
    defaultStatus = false,
    content = '',
    pad = false,
    linkOnly = false,
    linkHref = '',
    titleLink = false
}) => {
    
    const [status,setStatus] = useState(false)

    const handleChangeState = () => {
        if(status){
            setStatus(false)
            return
        }
        setStatus(true)
    }

    useEffect(() => {
        setStatus(defaultStatus)
    }, [defaultStatus])

    return (
        <>
            <div className="dropdown">
                <div className="dropdown-header" onClick={!linkOnly ? handleChangeState : null}>
                    <div className={linkOnly ? "dropdown-title link-only" : "dropdown-title"}>
                        { 
                        
                            linkOnly ? 
                            <>
                                <Link to={linkHref}>
                                    {title}
                                </Link>
                            </> : titleLink ?
                            <Link to={linkHref}>
                                {title}
                            </Link> : title
                        }
                    </div>{
                            !linkOnly ? 
                                <>
                                    <div className={status ? "dropdown-status open" : "dropdown-status"}>
                                        {
                                            status ? 
                                                <span>-</span> : <span>+</span>
                                        }
                                    </div>
                                </>
                            : ''
                    }
                </div>
                {
                    status ?
                        <>
                            <div className={pad ? "dropdown-section pad" : "dropdown-section"}>
                                {content}
                            </div>
                        </> : ''
                }
            </div>
        </>
    )
}

export default Dropdown